import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
export default function ProtectedRoute() {
    const isAuthenticated = useAuthStore((state)=>state.isAuthenticated);
    if (!isAuthenticated) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: "/login",
            replace: true
        });
    }
    return /*#__PURE__*/ _jsx(Outlet, {});
}
